export const heroImageMask = {
  name: 'hero-image-mask',
  path: 'M0,0 H1 V0.844 C1,0.844,0.728,0.993,0.489,1 C0.251,1,0,0.903,0,0.903 V0',
};

export const heroImageMaskMobile = {
  name: 'hero-image-mask',
  path: 'M0,0 L1,0 L1,0.902 C1,0.902,0.791,0.951,0.553,0.971 C0.315,0.99,0.17,0.994,0.001,1 L0,0',
};

export const heroImageMaskChal3 = {
  name: 'hero-image-mask-chal3',
  path: 'M0.045,0.373 C0.061,0.157,0.137,0,0.226,0 H0.988 C0.995,0,1,0.017,1,0.036 L0.945,0.752 C0.934,0.896,0.883,1,0.824,1 H0.012 C0.004,1,-0.001,0.983,0,0.964 L0.045,0.373',
};

export const heroImageMaskMobileChal3 = {
  name: 'hero-image-mask-chal3',
  path: 'M0,0.439 C0,0.197,0.099,0,0.22,0 H0.988 C0.995,0,1,0.01,1,0.023 V0.653 C1,0.845,0.922,1,0.826,1 H0.012 C0.005,1,0,0.99,0,0.977 V0.439',
};
